import React from 'react';
import { Link } from 'react-router-dom';

const allFeatures = [
  'Live calendar & availability',
  'Instant quote creation & tracking',
  'Mobile-first booking interface',
  'Email & push notifications',
  'Invoice generation & payment tracking',
  'CSV export for QuickBooks & Xero',
  'PDF invoice emailing',
  'Manage extras & upsells',
  'Guest booking conversion',
  'Colleague management & filtering',
  'Cancellation & change notifications',
  'Drop-off & pick-up workflows',
  'Service & repair booking',
  'Automated reminder emails',
];

const AllFeatures: React.FC = () => (
  <section className="container section animate-fadeInUp" id="all-features">
    <h2>Everything you need</h2>
    <ul className="features-grid">
      {allFeatures.map((feat, i) => (
        <li key={i} style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ color: 'var(--primary)', marginRight: '0.75rem', fontSize: '1.2rem' }}>
            ✓
          </span>
          <span style={{ fontWeight: 300, color: 'var(--text-light)' }}>{feat}</span>
        </li>
      ))}
    </ul>
    <div className="section-cta">
          <Link to="/get-started" className="cta">Get started for free</Link>
        </div>
  </section>
);

export default AllFeatures;
